import { Box, Stack } from '@mui/material';

import LoadingScreen from 'components/@common/LoadingScreen';

import Order from './Order';
import { EnrichedOrder } from './types';

interface Props {
  isLoading: boolean;
  orders: Array<EnrichedOrder>;
}

const OrderList = ({ isLoading, orders }: Props) => {
  return (
    <Stack spacing={1} flex={1}>
      {isLoading ? (
        <Box flexGrow={1} display="flex" minHeight="250px">
          <LoadingScreen />
        </Box>
      ) : (
        orders.map((order) => <Order key={order.id} {...order} />)
      )}
    </Stack>
  );
};

export default OrderList;
